"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [0, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var date_fns_1 = require("date-fns");

require("./date.less");

var DateInput = function (_super) {
  __extends(DateInput, _super);

  function DateInput(props) {
    var _this = _super.call(this, props) || this;

    var displayValue = props.value || new Date();
    _this.state = {
      value: props.value,
      isValid: !!props.value,
      displayValue: displayValue,
      showPicker: false,
      showYear: false
    };
    _this.togglePicker = _this.togglePicker.bind(_this);
    _this.onSelectDate = _this.onSelectDate.bind(_this);
    _this.onPrev = _this.onPrev.bind(_this);
    _this.onNext = _this.onNext.bind(_this);
    return _this;
  }

  DateInput.prototype.togglePicker = function (show) {
    var showPicker = !this.state.showPicker;

    if (show !== undefined) {
      showPicker = show;
    }

    this.setState({
      showPicker: showPicker
    });
  };

  DateInput.prototype.onSelectDate = function (date) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, context, field;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4
            /*yield*/
            , this.setState({
              value: date,
              displayValue: date,
              showPicker: false
            })];

          case 1:
            _b.sent();

            _a = this.props, context = _a.context, field = _a.field;
            context.onValue(field, date, true);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  DateInput.prototype.toggleYear = function (show) {
    var showYear = !this.state.showYear;

    if (show !== undefined) {
      showYear = show;
    }

    this.setState({
      showYear: showYear
    });
  };

  DateInput.prototype.onSelectYear = function (year) {
    this.setState({
      displayValue: year,
      showYear: false
    });
  };

  DateInput.prototype.onPrev = function () {
    var displayValue;

    if (this.state.showYear) {
      displayValue = date_fns_1.subYears(this.state.displayValue, 25);
    } else {
      displayValue = date_fns_1.subMonths(this.state.displayValue, 1);
    }

    this.setState({
      displayValue: displayValue
    });
  };

  DateInput.prototype.onNext = function () {
    var displayValue;

    if (this.state.showYear) {
      displayValue = date_fns_1.addYears(this.state.displayValue, 25);
    } else {
      displayValue = date_fns_1.addMonths(this.state.displayValue, 1);
    }

    this.setState({
      displayValue: displayValue
    });
  };

  DateInput.prototype.title = function () {
    if (this.state.showYear) {
      var displayValue = this.state.displayValue;
      var modulo = displayValue.getFullYear() % 25;
      var start = date_fns_1.subYears(new Date(displayValue), modulo);
      var end = date_fns_1.addYears(new Date(start), 24);
      return date_fns_1.format(start, "YYYY") + " - " + date_fns_1.format(end, "YYYY");
    } else {
      return date_fns_1.format(this.state.displayValue, "MMMM YYYY");
    }
  };

  DateInput.prototype.footer = function () {
    var _this = this;

    var switchYear = "";

    if (this.props.switchYear) {
      var classNames = ["year"];

      if (this.state.showYear) {
        classNames.push("active");
      }

      switchYear = React.createElement("span", {
        className: classNames.join(" "),
        onClick: function onClick() {
          return _this.toggleYear();
        }
      }, "Switch Year");
    }

    return React.createElement("div", {
      className: "footer"
    }, switchYear, React.createElement("span", {
      className: "today",
      onClick: function onClick() {
        var today = date_fns_1.startOfDay(new Date());

        _this.onSelectDate(today);
      }
    }, "Today"), React.createElement("span", {
      className: "close",
      onClick: function onClick() {
        return _this.togglePicker(false);
      }
    }, "Close"));
  };

  DateInput.prototype.picker = function () {
    var _this = this;

    var displayValue = this.state.displayValue;

    if (this.state.showYear) {
      var modulo = displayValue.getFullYear() % 25;
      var start = date_fns_1.subYears(new Date(displayValue), modulo);
      var end = date_fns_1.addYears(new Date(start), 25);
      var options = [];
      var year = new Date(start);

      while (date_fns_1.isBefore(year, end)) {
        options.push(year);
        year = date_fns_1.addYears(year, 1);
      }

      return React.createElement("div", {
        className: "year-picker"
      }, options.map(function (year, key) {
        var classNames = ["year"];

        if (date_fns_1.isSameYear(year, _this.state.value)) {
          classNames.push("active");
        }

        return React.createElement("div", {
          className: classNames.join(" "),
          key: key,
          onClick: function onClick() {
            return _this.onSelectYear(year);
          }
        }, React.createElement("div", {
          className: "content"
        }, date_fns_1.format(year, "YYYY")));
      }));
    } else {
      var start = date_fns_1.startOfWeek(date_fns_1.startOfMonth(displayValue), {
        weekStartsOn: 1
      });
      var end = date_fns_1.endOfWeek(date_fns_1.endOfMonth(displayValue), {
        weekStartsOn: 1
      });
      var options = [];
      var date = new Date(start);

      while (date_fns_1.isBefore(date, end)) {
        options.push(date);
        date = date_fns_1.addDays(date, 1);
      }

      return React.createElement("div", {
        className: "month-calendar"
      }, ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(function (header, key) {
        return React.createElement("span", {
          className: "header",
          key: key
        }, header);
      }), options.map(function (date, key) {
        var disabled = false;

        if (_this.props.validateFn) {
          disabled = !_this.props.validateFn(date);
        }

        var classNames = ["day"];

        if (!date_fns_1.isSameMonth(date, _this.state.displayValue)) {
          classNames.push("outside");
        }

        if (date_fns_1.isSameDay(date, _this.state.value)) {
          classNames.push("active");
        }

        if (disabled) {
          classNames.push("disabled");
        }

        return React.createElement("div", {
          className: classNames.join(" "),
          key: key,
          onClick: function onClick() {
            if (!disabled) {
              _this.onSelectDate(date);
            }
          }
        }, React.createElement("div", {
          className: "content"
        }, date_fns_1.format(date, "DD")));
      }));
    }
  };

  DateInput.prototype.componentWillReceiveProps = function (nextProps) {
    if (nextProps.value) {
      var value = nextProps.value;
      var displayValue = nextProps.value;
      var isValid = true;
      this.setState({
        value: value,
        displayValue: displayValue,
        isValid: isValid
      });
    }
  };

  DateInput.prototype.render = function () {
    var _this = this;

    var label = "";

    if (this.props.label) {
      label = React.createElement("label", null, this.props.label);
    }

    var classNames = ["input", "date-input"];

    if (this.state.showPicker) {
      classNames.push("active");
    }

    var text = "";

    if (this.state.value) {
      var displayFormat = this.props.displayFormat || "dddd Do MMMM, YYYY";
      text = date_fns_1.format(this.state.value, displayFormat);
    }

    return React.createElement("div", {
      className: classNames.join(" "),
      onFocus: function onFocus() {
        return _this.togglePicker(true);
      }
    }, label, React.createElement("input", {
      type: "text",
      value: text,
      readOnly: true,
      placeholder: this.props.placeholder || "Select a date"
    }), React.createElement("div", {
      className: "date-picker"
    }, React.createElement("div", {
      className: "title"
    }, React.createElement("span", {
      className: "nav prev",
      onClick: function onClick() {
        return _this.onPrev();
      }
    }), React.createElement("span", null, this.title()), React.createElement("span", {
      className: "nav next",
      onClick: function onClick() {
        return _this.onNext();
      }
    })), React.createElement("div", null, this.picker(), this.footer())));
  };

  return DateInput;
}(React.Component);

exports["default"] = DateInput;